export * from './InformativeCard';
